/*
 * HP Product Main — interactive logic
 * Pack selector with quantity multiplication and live pricing.
 * Discount % is for display only — set up Shopify Automatic Discounts
 * (Discounts → Create → Amount off products) to actually charge less.
 */
(function () {
  'use strict';

  function formatMoney(cents, currencyFormat) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0];
    var decimal = parts[1];
    // Default EUR format; replace placeholders if format provided by Shopify
    if (currencyFormat && currencyFormat.indexOf('{{amount}}') > -1) {
      var display = whole + ',' + decimal;
      return currencyFormat.replace('{{amount}}', display).replace(/<[^>]+>/g, '');
    }
    return '€' + whole + ',' + decimal;
  }

  function init(section) {
    var variantsScript = section.querySelector('[data-product-json]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var form = section.querySelector('[data-product-form]');
    var optionInputs = section.querySelectorAll('[data-option-input]');
    var packLabels = section.querySelectorAll('[data-pack]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyDec = section.querySelector('[data-qty-action="dec"]');
    var qtyInc = section.querySelector('[data-qty-action="inc"]');
    var hiddenId = section.querySelector('[data-variant-id]');
    var priceCurrent = section.querySelector('[data-price-current]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var priceSavings = section.querySelector('[data-price-savings]');
    var submitBtn = section.querySelector('[data-submit]');
    var submitText = section.querySelector('[data-submit-text]');

    // Gallery
    var thumbs = section.querySelectorAll('[data-thumb-index]');
    var slides = section.querySelectorAll('[data-slide-index]');
    var dots = section.querySelectorAll('[data-dot-index]');

    // Sticky bar
    var sticky = section.querySelector('[data-sticky]');
    var stickyVariant = section.querySelector('[data-sticky-variant]');
    var stickyPack = section.querySelector('[data-sticky-pack]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyCta = section.querySelector('[data-sticky-cta]');
    var ctaRow = section.querySelector('.hp-pp__cta-row');

    var state = {
      variant: variants.find(function (v) { return v.id; }) || variants[0],
      packQty: 1,
      packDiscount: 0,
      packTitle: '1 Pack',
      userQty: 1
    };

    // ============ Variant logic ============
    function findVariantBySelectedOptions() {
      var selectedValues = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          selectedValues[parseInt(input.closest('[data-option-index]').getAttribute('data-option-index'), 10)] = input.value;
        }
      });
      // Find variant whose options array matches selectedValues exactly
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedValues[i] === undefined || opt === selectedValues[i];
        });
      });
    }

    function setActiveVariant(variant) {
      if (!variant) return;
      state.variant = variant;
      hiddenId.value = variant.id;

      // Visual state of variant pills
      optionInputs.forEach(function (input) {
        var label = input.closest('.hp-pp__variant-option');
        if (input.checked) label.classList.add('is-active');
        else label.classList.remove('is-active');
      });

      // Switch gallery to variant image if available
      if (variant.featured_media && variant.featured_media.position) {
        showSlide(variant.featured_media.position - 1);
      }

      // Update availability
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          if (submitText) submitText.textContent = 'ADD TO CART';
        } else {
          submitBtn.disabled = true;
          if (submitText) submitText.textContent = 'SOLD OUT';
        }
      }

      if (stickyVariant) stickyVariant.textContent = variant.title;

      updatePricing();
    }

    // ============ Pack logic ============
    function setActivePack(label) {
      packLabels.forEach(function (l) { l.classList.remove('is-active'); });
      label.classList.add('is-active');
      var input = label.querySelector('.hp-pp__pack-input');
      if (input) input.checked = true;

      state.packQty = parseInt(label.getAttribute('data-pack-qty'), 10) || 1;
      state.packDiscount = parseFloat(label.getAttribute('data-pack-discount')) || 0;
      state.packTitle = label.getAttribute('data-pack-title') || (state.packQty + ' Pack');

      if (stickyPack) stickyPack.textContent = state.packTitle;

      updatePricing();
    }

    // ============ Pricing ============
    function updatePricing() {
      var variant = state.variant;
      if (!variant) return;

      var basePrice = variant.price; // cents
      var totalQty = state.packQty * state.userQty;
      var fullPrice = basePrice * totalQty;
      var discountedPrice = fullPrice * (1 - state.packDiscount / 100);

      priceCurrent.textContent = formatMoney(discountedPrice);

      if (state.packDiscount > 0) {
        priceCompare.textContent = formatMoney(fullPrice);
        var saveLabel = section.getAttribute('data-you-save-label') || 'You save';
        priceSavings.textContent = saveLabel.toUpperCase() + ' ' + formatMoney(fullPrice - discountedPrice);
      } else {
        priceCompare.textContent = '';
        priceSavings.textContent = '';
      }

      if (stickyPrice) stickyPrice.textContent = formatMoney(discountedPrice);
    }

    // ============ Quantity logic ============
    function setQty(n) {
      n = Math.max(1, parseInt(n, 10) || 1);
      state.userQty = n;
      qtyInput.value = n;
      updatePricing();
    }

    // ============ Gallery ============
    function showSlide(index) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      var t = section.querySelector('[data-thumb-index="' + index + '"]');
      var s = section.querySelector('[data-slide-index="' + index + '"]');
      var d = section.querySelector('[data-dot-index="' + index + '"]');
      if (t) t.classList.add('is-active');
      if (s) s.classList.add('is-active');
      if (d) d.classList.add('is-active');
    }

    // ============ Event bindings ============
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariantBySelectedOptions();
        setActiveVariant(variant);
      });
    });

    packLabels.forEach(function (label) {
      label.addEventListener('click', function () { setActivePack(label); });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(parseInt(thumb.getAttribute('data-thumb-index'), 10));
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-dot-index'), 10));
      });
    });

    if (qtyDec) qtyDec.addEventListener('click', function () { setQty(state.userQty - 1); });
    if (qtyInc) qtyInc.addEventListener('click', function () { setQty(state.userQty + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
      qtyInput.addEventListener('input', function () { setQty(qtyInput.value); });
    }

    // ============ AJAX add to cart — opens cart drawer instead of going to checkout ============
    function addToCart() {
      if (!form) return;
      if (submitBtn && submitBtn.disabled) return;

      // Multiply quantity by pack size
      qtyInput.value = state.packQty * state.userQty;

      var cartTarget = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      // Set loading state
      if (submitBtn) {
        submitBtn.classList.add('loading');
        submitBtn.setAttribute('aria-disabled', 'true');
      }

      var formData = new FormData(form);

      // Ask Shopify to return cart drawer section HTML so we can swap it in
      if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
        var sectionIds = cartTarget.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);
        if (typeof cartTarget.setActiveElement === 'function') {
          cartTarget.setActiveElement(document.activeElement);
        }
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            // Error from Shopify (e.g. sold out)
            console.error('Cart error:', response.description || response.message);
            return;
          }

          if (cartTarget && typeof cartTarget.renderContents === 'function') {
            cartTarget.renderContents(response);
            if (cartTarget.classList.contains('is-empty')) cartTarget.classList.remove('is-empty');
          } else {
            // Fallback when there's no drawer — go to cart page
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('aria-disabled');
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    if (stickyCta) {
      stickyCta.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    // ============ Sticky bar visibility ============
    if (sticky && ctaRow) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0 });
      observer.observe(ctaRow);
    }

    // ============ Init ============
    // Initialise pack state from any default
    var defaultPack = section.querySelector('.hp-pp__pack.is-active') || packLabels[0];
    if (defaultPack) {
      state.packQty = parseInt(defaultPack.getAttribute('data-pack-qty'), 10) || 1;
      state.packDiscount = parseFloat(defaultPack.getAttribute('data-pack-discount')) || 0;
      state.packTitle = defaultPack.getAttribute('data-pack-title') || '1 Pack';
      if (stickyPack) stickyPack.textContent = state.packTitle;
    }

    // Initial variant
    var initialVariant = findVariantBySelectedOptions() || variants[0];
    setActiveVariant(initialVariant);
  }

  function boot() {
    document.querySelectorAll('[data-hp-pp]').forEach(function (el) {
      if (el.__hpPpReady) return;
      el.__hpPpReady = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
